/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import ImagePane from 'material/embeds/imageapi/imagepane/imagepane';
import ImageToggle from 'material/embeds/imageapi/imagepane/pane/images/image_toggle_container';
import Giphys from 'material/embeds/imageapi/imagepane/pane/giphys/giphys_container';
import ShutterStock from 'material/embeds/imageapi/imagepane/pane/images/shutterstock/shutterstock_container';
import Unsplash from 'material/embeds/imageapi/imagepane/pane/images/unsplash/unsplash_container'
import YourOwn from 'material/embeds/imageapi/imagepane/pane/yourown/yourown_container';
import Controller from 'material/embeds/imageapi/controller/controller';
import PageButtons from 'material/embeds/imageapi/pagebuttons/pagebuttons';
// utils
import { debounce } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imageapi_styles';



/* ========== ~~~~~~~~~~ IMAGE API ~~~~~~~~~~ ========== */
class ImageAPI extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tabSelected: 'images',
			imageTabSelected: 'unsplash',
			searchTerm: '',
			page: 1
		};
		// this variable is used to track a component status to prevent setState methods to be called from async success callbacks.
		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.pagination = this.pagination.bind(this);
		this.renderImagePane = this.renderImagePane.bind(this);
		this.handleImageTabSelect = this.handleImageTabSelect.bind(this);
	};

	componentWillUnmount() {
		this.props.clearImageTab();
	}

	handleTabSelect(tab) {
		if (tab === this.state.tabSelected) {
			return null;
		} else {
			this.setState({ tabSelected: tab, imageTabSelected: 'unsplash', page: 1 })
		}
	};

	handleImageTabSelect(imageTab) {
		if (imageTab === this.state.imageTabSelected) {
			return null;
		} else {
			this.setState({ imageTabSelected: imageTab, page: 1 })
		}
	};

	pagination(next) {
		if (next) {
			this.setState({ page: this.state.page + 1 })
		} else {
			if (this.state.page > 1) {
				this.setState({ page: this.state.page - 1 })
			} else {
				return null;
			}
		}
	};

	renderImagePane() {
		switch (this.state.imageTabSelected) {
			case 'shutterstock':
				return <ShutterStock query={this.state.searchTerm} page={this.state.page} />;
			case 'unsplash':
			default:
				return <Unsplash query={this.state.searchTerm} page={this.state.page} />
		}
	}

	saveSearchTerm = debounce(term => {
		this.setState({ searchTerm: term, page: 1});
	}, 500);

	renderPane() {
		switch (this.state.tabSelected) {
			case 'giphy':
				return <Giphys query={this.state.searchTerm} page={this.state.page} />;
			case 'images':
				return this.renderImagePane();
			case 'yourOwn':
			default:
				return <YourOwn resetQuery={this.saveSearchTerm}/>
		}
	};

	render() {
		return (
			<div className={`imageapi ${this.props.classes.imageapi}`} >
				<Controller saveSearchTerm={this.saveSearchTerm} tab={this.state.tabSelected} tabSelect={this.handleTabSelect} />
				{this.state.tabSelected === 'images' && this.props.mocked ? <ImageToggle imageTabSelect={this.handleImageTabSelect} imageTab={this.state.imageTabSelected}/> : null}
				<ImagePane> {this.renderPane()} </ImagePane>
				{this.state.tabSelected !== 'yourOwn' && <PageButtons pages={this.props.pageCount>this.state.page} page={this.state.page} pagination={this.pagination} />}
			</div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageAPI);
